import { Box, Button, Typography } from "@mui/material";
import LocationSelect from "./LocationSelect";
import ControlSection from "./ControlSection";
import { useSelector } from "react-redux";
import { uploadDocuments } from "../../../../store/actions/documentAction";
export default function UploadSidePanel({
  location,
  setLocation,
  controls,
  setControls,
  setSelectedFile,
  setUploadStatus,
  activeControlId,
  setActiveControlId,
  selectedFile,
  onUploadSuccess  
}) {
    const ordersLocation = useSelector(
    ({ orderReducer }) => orderReducer.ordersLocation
);
  const isControlComplete = control => {
    const controlNo = String(control?.controlNo ?? "").trim();
    return (
      controlNo.length > 0 &&
      Boolean(control?.docType) &&
      Array.isArray(control?.files) &&
      control.files.length > 0
    );
  };

  const canAddControl = controls.length === 0 || controls.every(isControlComplete);

  const addControl = () => {
    if (!canAddControl) {
      return;
    }

    const newId=Date.now()
    setControls([
      ...controls,
      { id:newId, controlNo: "", docType: null, files: [] }
    ]);
    setActiveControlId(newId)
  };
  const removeControl = id => {
    setControls(prev => prev.filter(c => c.id !== id));
  
    if (id === activeControlId) {
      setActiveControlId(null);
    }
  
    setSelectedFile(null);
  };

  const canUpload =
    controls.length > 0 &&
    controls.every(isControlComplete);
 
  const uploadAll = async () => {
    if (!canUpload) {
      setUploadStatus({
        type: "error",
        message: "Please enter control number, select document type, and upload documents for all controls"
      });
      return;
    }

    setUploadStatus({ type: "info", message: "Uploading..." });
    try {
    const formData = new FormData();
  
    // formData.append("location", ordersLocation?.locationNumber);
    const locationNumber = ordersLocation?.locationNumber;
  
    controls.forEach((doc, index) => {
      formData.append(`documents[${index}][id]`, doc.id);
      formData.append(`documents[${index}][controlNo]`, doc.controlNo);
      formData.append(`documents[${index}][docTypeCode]`, doc.docType?.code);
      formData.append(`documents[${index}][docTypeId]`, doc.docType?.id);
  
      doc.files.forEach(file => {
        formData.append(`documents[${index}][files]`, file);
      });
    });
  
    // await uploadDocuments(formData);
    await uploadDocuments(locationNumber, formData);
    setUploadStatus({ type: "success", message: "Upload successful" });
    setControls([
      { id: 1, controlNo: "", docType: null, files: [] }
    ])
    setSelectedFile(null);

    //  CLOSE MODAL + REFRESH DATA
    onUploadSuccess?.();
  } catch (err) {
    console.error(err);
    setUploadStatus({ type: "error", message: "Upload failed" });
  }
  };
  
  return (
    <Box width={340} p={1} borderRight="1px solid #ddd" overflow="auto">
      <Typography fontWeight={600}>DOCUMENT UPLOAD</Typography>
      {/* <LocationSelect value={location} onChange={setLocation} /> */}
      {controls.map(control => (
        <ControlSection
          key={control.id}
          control={control}
          isActive={control.id===activeControlId}
          setActive={()=>setActiveControlId(control.id)}
          controls={controls}
          setControls={setControls}
          setSelectedFile={setSelectedFile}
          selectedFile={selectedFile}
          removeControl={removeControl}
        />
      ))}
      <Button fullWidth onClick={addControl} sx={{ mt: 1 }} disabled={!canAddControl}>
        + Add Control #
      </Button>
      <Button
        fullWidth
        variant="contained"
        sx={{ mt: 1 }}
        onClick={uploadAll}
        disabled={!canUpload}
      >
        UPLOAD
      </Button>
    </Box>
  );
}